class Store {
    constructor() {
        this.$data = {};
        this.$timer = null;
    }
    
    set(key, data) {
        /*try {
            localStorage.setItem('react_weather_component_'+String(key), JSON.stringify(data));
        } catch(e) {
            return false;
        }*/
        this.$data[key] = data;
        return this;
    }
    
    get(key) {
        /*const data = localStorage.getItem('react_weather_component_'+String(key));
        return data ? JSON.parse(data) : null;*/
        return Object.prototype.hasOwnProperty.call(this.$data, key) ? this.$data[key] : null;
    }
    
    del(key) {
        /*localStorage.removeItem('react_weather_component_'+String(key));*/
        if ( Object.prototype.hasOwnProperty.call(this.$data, key) ) delete this.$data[key];
        return this;
    }
    
    clear()  {
        this.$data = {};
        return this;
    }
    
    autoclear(interval) {
        if ( this.$timer ) {
            clearTimeout(this.$timer);
            this.$timer = null;
        }
        const clear = ( ) => {
            this.clear();
            this.$timer = setTimeout(clear, interval);
        };
        this.$timer = setTimeout(clear, interval);
        return this;
    }
}

// singleton
export default new Store().autoclear(30 * 60 * 1000); // auto-clear every 30 minutes


